import { makeStyles } from '@material-ui/styles';
import { white } from '../../../constants/Colors';

export default makeStyles(() => ({
    showbox: {
        zIndex: 100000,
        position: 'fixed',
        backgroundColor: ({ transparentBackground }) => `rgba(255, 255, 255, ${transparentBackground ? '0' : '0.8'})`,
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
    },
    text: {
        fontSize: '42px',
        textAlign: 'center',
        marginBottom: '80px',
        fontWeight: 'bolder',
        color: white,
        position: 'relative',
        top: '50%',
    },
    ngLoader: {
        top: '50%',
        left: '50%',
        position: 'relative',
        marginTop: ({ height }) => `-${height / 2}px`,
        marginLeft: ({ width }) => `-${width / 2}px`,
        width: ({ width }) => `${width}px`,
        height: ({ height }) => `${height}px`,
        '&:before': {
            content: '',
            display: 'block',
            paddingTop: '100%',
        },
    },
    ldCircular: {
        width: '100% !important',
        height: '100% !important',
        animation: 'rotate 2s linear infinite !important',
        transformOrigin: 'center center !important',
        position: 'absolute !important',
        top: '0 !important',
        bottom: '0 !important',
        left: '0 !important',
        right: '0 !important',
        margin: 'auto !important',
    },
    ldPath: {
        stroke: ({ color }) => color,
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0',
        animation: 'dash 1.5s ease-in-out infinite',
        strokeLinecap: 'round',
    },
}));
